import React, { useState } from 'react'


import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import { Button, TextField } from '@material-ui/core'
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';

import { MEMO_MAX, memoError } from '../memo'

function CreateNotificationMemo(props) {
  const [text, setText] = useState('')
  // Что не так с текстом: показывается, когда человек нажал «Создать Заметку».
  const [problem, setProblem] = useState('')
  return (
    <Grid component={Paper} container spacing={3}>
      <Grid item xs={12}>
          <FormControl fullWidth>
          <Typography variant={'h5'} align={'center'}>
          Создание Заметки
            </Typography>
          </FormControl>
        </Grid>  
    <Grid item xs={12}>
      <FormControl fullWidth>
        <TextField
          id="outlined-basic"
          multiline
          label="Описание события"
          variant="outlined"
          value={text}
          error={Boolean(problem)}
          helperText={problem}
          inputProps={{ maxLength: MEMO_MAX }}
          onChange={e => {
            setText(e.target.value)
            setProblem('')
          }}
        />
      </FormControl>
    </Grid>
    <Grid item xs={6}>
      <FormControl fullWidth>
        <Button variant="contained" color="secondary" disabled={props.saving} onClick={props.editAction}>Отмена</Button>
      </FormControl>
    </Grid>
    <Grid item xs={6}>
      <FormControl fullWidth>
        <Button variant="contained" color="primary" disabled={props.saving} onClick={() => {
          // Пустая заметка (в том числе из одних пробелов) не сохраняется, форма остаётся открытой.
          const found = memoError(text)
          if (found) {
            setProblem(found)
            return
          }
          // Форма закрывается, когда сервер ответил успехом: если не удалось, текст остаётся.
          Promise.resolve(props.createNotificationMemo({ companyId: props.companyId, description: text.trim() })).then((result) => {
            if (!result || !result.error) props.editAction()
          })
        }}>Создать Заметку</Button>
      </FormControl>
    </Grid>
  </Grid>
  )
}

export default CreateNotificationMemo
